var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c(_vm.comp,_vm._b({ref:"formItem",tag:"component",on:{"onInput":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'component',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }